export default __webpack_public_path__ + "static/media/3435 knife block B side.38bc539e.png";